const recommendations = [
  {
    icon: 'ri-sound-module-line',
    title: 'Sona 2 Cruise',
    subtitle: 'Estimulación externa sin contacto',
    description: 'Perfecto si buscas placer clitoral intenso sin contacto directo. Ideal para quienes prefieren sensaciones suaves pero profundas.',
    color: 'from-pink-500 to-rose-500'
  },
  {
    icon: 'ri-contrast-2-line',
    title: 'Soraya Wave',
    subtitle: 'Doble estimulación simultánea',
    description: 'La elección perfecta si quieres estimulación interna y externa al mismo tiempo. Su tecnología WaveMotion imita el movimiento de los dedos.',
    color: 'from-fuchsia-500 to-purple-500'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Enigma',
    subtitle: 'Succión + vibración profunda',
    description: 'Combina lo mejor de dos mundos: ondas sónicas externas y vibración interna potente. Para orgasmos más intensos.',
    color: 'from-violet-500 to-fuchsia-500'
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Hugo',
    subtitle: 'Próstata y uso masculino',
    description: 'Diseñado específicamente para el placer masculino. Estimulación de próstata con control remoto para jugar solo o en pareja.',
    color: 'from-blue-500 to-cyan-500'
  },
  {
    icon: 'ri-smartphone-line',
    title: 'F1s V2',
    subtitle: 'Tecnología Sensonic™ para hombres',
    description: 'Control por app y estimulación envolvente en 360°.',
    color: 'from-fuchsia-500 to-purple-500'
  },
  {
    icon: 'ri-heart-2-line',
    title: 'Tiani 3',
    subtitle: 'Uso en pareja',
    description: 'Perfecto para usar durante el sexo. Se lleva puesto y estimula a ambos. Control remoto para que tu pareja tome el control.',
    color: 'from-rose-500 to-pink-500'
  }
];

export default function BuyingGuide() {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-pink-50/30 to-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-fuchsia-100 text-fuchsia-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-question-line"></i>
            <span>Guía de compra</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            ¿Cuál elegir?
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed px-2">
            ¿Buscas estimulación externa o interna? ¿Quieres jugar sola o en pareja? 
            Te ayudamos a encontrar tu LELO ideal según tus preferencias.
          </p>
        </div>

        {/* Recommendations Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <div className="bg-white/80 backdrop-blur-sm p-5 sm:p-6 rounded-xl border-2 border-fuchsia-200 hover:border-fuchsia-400 transition-all duration-300">
            <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-pink-500 rounded-full flex items-center justify-center mb-4">
              <i className="ri-sound-module-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Sona 2 Cruise</h3>
            <p className="text-gray-600 text-sm">Estimulación externa sin contacto. Ideal para quienes buscan sensaciones suaves y envolventes.</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-5 sm:p-6 rounded-xl border-2 border-fuchsia-200 hover:border-fuchsia-400 transition-all duration-300">
            <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-pink-500 rounded-full flex items-center justify-center mb-4">
              <i className="ri-heart-pulse-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Soraya Wave</h3>
            <p className="text-gray-600 text-sm">Doble estimulación simultánea. Perfecta para orgasmos más completos e intensos.</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-5 sm:p-6 rounded-xl border-2 border-fuchsia-200 hover:border-fuchsia-400 transition-all duration-300">
            <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-pink-500 rounded-full flex items-center justify-center mb-4">
              <i className="ri-flashlight-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Enigma</h3>
            <p className="text-gray-600 text-sm">Succión + vibración profunda. Para quienes quieren experimentar sensaciones combinadas.</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-5 sm:p-6 rounded-xl border-2 border-fuchsia-200 hover:border-fuchsia-400 transition-all duration-300">
            <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-pink-500 rounded-full flex items-center justify-center mb-4">
              <i className="ri-user-heart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Hugo</h3>
            <p className="text-gray-600 text-sm">Estimulación de próstata masculina. Diseñado para el placer masculino con control remoto.</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-5 sm:p-6 rounded-xl border-2 border-fuchsia-200 hover:border-fuchsia-400 transition-all duration-300">
            <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-pink-500 rounded-full flex items-center justify-center mb-4">
              <i className="ri-smartphone-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">F1s V2</h3>
            <p className="text-gray-600 text-sm">Tecnología Sensonic™ para hombres. Control por app y estimulación envolvente en 360°.</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-5 sm:p-6 rounded-xl border-2 border-fuchsia-200 hover:border-fuchsia-400 transition-all duration-300">
            <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-pink-500 rounded-full flex items-center justify-center mb-4">
              <i className="ri-heart-2-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Tiani 3</h3>
            <p className="text-gray-600 text-sm">Uso en pareja. Estimulación simultánea para ambos con control remoto inalámbrico.</p>
          </div>
        </div>

        {/* Help Box */}
        <div className="mt-10 sm:mt-12 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-2xl sm:rounded-3xl p-6 sm:p-8 text-center text-white">
          <i className="ri-lightbulb-line text-4xl sm:text-5xl mb-4"></i>
          <h3 className="text-xl sm:text-2xl font-bold mb-3">¿Aún tienes dudas?</h3>
          <p className="text-sm sm:text-base text-white/90 mb-6 max-w-2xl mx-auto px-2">
            Todos los productos LELO vienen con garantía de 1 año, son 100% resistentes al agua 
            y están fabricados con silicona de grado médico. No puedes equivocarte.
          </p>
          <a
            href="#faq"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-white text-fuchsia-600 hover:bg-gray-50 px-6 sm:px-8 py-3 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 cursor-pointer"
          >
            <span>Ver preguntas frecuentes</span>
            <i className="ri-arrow-down-line text-lg sm:text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
